export default "__VITE_ASSET__CWOBttR1__"